import { Pipe, PipeTransform } from '@angular/core';
import { CourseLevelEnum, CourseLevelEnumDescriptions } from '../../models/enums/courseLevelEnum';
import { StudentListForSuperAdminResponse } from '../../models/super-admin/studentListForSuperAdminResponse';

@Pipe({
  name: 'shouldShowParentsInfo',
  pure: true,
  standalone: true
})
export class ShouldShowParentsInfoPipe implements PipeTransform {

  private readonly levelsNeedingParentsInfo = [
    CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsDegree],
    CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsAndMastersDegree],
    CourseLevelEnumDescriptions[CourseLevelEnum.Certificate],
    CourseLevelEnumDescriptions[CourseLevelEnum.Diploma],
    CourseLevelEnumDescriptions[CourseLevelEnum.FoundationDegree],
    CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateCertificate],
    CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateDiploma],
    CourseLevelEnumDescriptions[CourseLevelEnum.Vocational]
  ];

  transform(student: StudentListForSuperAdminResponse): boolean {
    if (!student.degreePreference) {
      return false;
    }

    return this.levelsNeedingParentsInfo.includes(student.degreePreference);
  }
}
